import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Usage: provide a heading, optional actions via [panel-actions], and projected content. */
@Component({
  selector: 'app-section-panel',
  templateUrl: './app-section-panel.component.html',
  styleUrls: ['./app-section-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSectionPanelComponent {
  @Input() heading = '';
  @Input() empty = false;
  @Input() ariaLabel = '';
}
